import { render, staticRenderFns } from "./ketohc.vue?vue&type=template&id=bc92e828&"
import script from "./ketohc.vue?vue&type=script&lang=js&"
export * from "./ketohc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports